import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { AnalyticsService } from './analytics.service';

/** Router waits for Replay teardown before rendering a different route. */
export const registrationReplayExitGuard: CanDeactivateFn<unknown> = () =>
  inject(AnalyticsService).setReplayViewAllowed(false).then(() => true, () => false);
